import { ExpectedAmountSize } from "@simplyk/common";

export const SUGGESTED_AMOUNTS = {
  OneTime: {
    [ExpectedAmountSize.Small]: [2500, 5000, 7500, 10000],
    [ExpectedAmountSize.Medium]: [2500, 5000, 10000, 25000],
    [ExpectedAmountSize.Big]: [5000, 10000, 30000, 50000],
  },
  Monthly: [1000, 2500, 3500, 4500],
  Yearly: [10000, 25000, 35000, 45000],
};
